import { CostCentersHeader, CostCentersTable } from '@pages/cost-centers/containers';
import { useTranslation } from 'react-i18next';
import { Typography } from '@ui/components';

export const CostCenters = () => {
  const { t } = useTranslation();
  return (
    <>
      <CostCentersHeader>
        <Typography variant="h300" element="h1">
          {t('COST_CENTERS.TITLE')}
        </Typography>
      </CostCentersHeader>
      <CostCentersTable />
    </>
  );
};
